import { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../../componentes/Comunes/PageHeading";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";

export default class Formularios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaFormularios: [],
    };
    this._descargarFormulario = this._descargarFormulario.bind(this);
  }

  async componentDidMount() {
    await this.cargarDatos();
  }

  async cargarDatos() {
    var formularios = await ServicioAutorizaciones.ObtengaListaFormularios();
    this.setState({
      listaFormularios: formularios,
    });
  }

  _descargarFormulario(formulario) {
    window.location.href = formulario.formulario;
  }

  render() {
    return (
      <Layout>
        <div>
          <PageHeading
            title={"Formularios para autorizaciones y revocaciones"}
          />
          <div>
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Formularios
                </h6>
              </div>

              <div className="card-body">
                {this.state.listaFormularios.map((item, index) => (
                  <div
                    className="input-group mb-4 col-md-6"
                    key={item.nombreFormulario}
                  >
                    <input
                      id={"i_" + index}
                      type="text"
                      name="Reportes"
                      value={item.nombreFormulario}
                      className="form-control"
                      readOnly
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        onClick={() => this._descargarFormulario(item)}
                        className="btn btn-primary btn-icon-split"
                      >
                        <span className="icon text-white-50">
                          <i className="fas fa-download"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
